import { faker } from '@faker-js/faker'

import { asBuilder } from '../asBuilder'
import { AdminReviewRewardListItem } from '../../contracts/review/AdminReviewRewardListItem'
import { OperationType } from '../../contracts/treatment'
import { ReviewAuthorCountry } from '../../contracts/review'
import { ReviewHospitalCountry } from '../../contracts/review/ReviewCountry'

export const getAdminReviewRewardListItem = asBuilder((): AdminReviewRewardListItem => {
  return {
    reviewId: faker.number.int(),
    pointRewardType: faker.helpers.arrayElement(['COMPLETED_PROGRESSES_WITH_MINIMUM_COUNTS', 'BEFORE_AFTER_PHOTO']),
    postedAtUtc: faker.date.recent().toUTCString(),
    progressCompletedAtUtc: faker.date.recent().toUTCString(),
    lastProgressDateUtc: faker.date.recent().toUTCString(),
    operationType: faker.helpers.enumValue(OperationType),
    authorId: faker.number.int(),
    authorCountry: faker.helpers.enumValue(ReviewAuthorCountry),
    hospitalCountry: faker.helpers.enumValue(ReviewHospitalCountry),
    authorNickname: faker.person.firstName(),
    verificationStatus: faker.helpers.arrayElement(['PENDING', 'COMPLETED', 'REJECTED']),
    rewardStatus: faker.helpers.arrayElement(['PENDING', 'COMPLETED', 'REJECTED', 'SCHEDULED', 'FAILED', 'REWARDING']),
    memo: faker.lorem.sentence(),
    progressCount: faker.number.int(),
    expectedPoint: faker.number.int(),
  }
})
